import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { MeidouInfoType } from '@meitu/xdesign-widgets/dist/types/meidouInfo';

export interface IMeidouModel {
    meidouInfo: MeidouInfoType | null;
    setMeidouInfo: (payload: MeidouInfoType) => void;
}

const useMeidouModel = create<IMeidouModel>()(
    immer((set) => ({
        meidouInfo: null,
        setMeidouInfo: (payload) =>
            set((state) => {
                const { total_amount, available_amount } = payload;
                state.meidouInfo = { total_amount, available_amount };
            }),
    })),
);

export { useMeidouModel };
export const getMeidouModel = () => useMeidouModel.getState();
